export const backgroundImage = new Image();
export async function getBackgroundImage(url) {
    return new Promise((resolve, reject) => {
        backgroundImage.onload = () => resolve(backgroundImage);
        backgroundImage.onerror = (err) => {
            backgroundImage.complete = false
            reject(err)
        };
        backgroundImage.src = url;
    });
}
